module.exports = __webpack_public_path__ + "img/background11.41b411a2.webp";